module.exports = __webpack_public_path__ + "087bde2ebe08abe37dd1dfd5a89f6f84.svg";